import Box from "@mui/material/Box";
import { useContext, useEffect, useRef, useState } from "react";
import { Loading } from "react-admin";
import { useParams } from "react-router";
import { APIContext } from "../../../store/APIStore";
import { StoreContext } from "../../../store/Store";
import NotificationMessage, {
  notificationType,
} from "../../../components/NotificationMessage/NotificationMessage";
import { RiAddCircleLine } from "react-icons/ri";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import CategoryForm from "./CategoryForm";
import CategoryList from "./CategoryList";
import { category as classes } from "./styles";
import {
  ICategoriesState,
  initCategoriesList,
} from "../../../helpers/constants";
import {
  IAttendeeCategory,
  IAttendeeCountCategory,
} from "../../../dataProvider/interfaces/IEvent";
import { BiGridAlt } from "react-icons/bi";

const CategoryOverview = () => {
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const notificationRef = useRef<any>();
  const { eventId } = useParams() as { eventId: string };
  const [isLoading, setLoading] = useState<boolean>(true);

  const fetchAttendeeCategories = async () => {
    let apiState: ICategoriesState = { ...initCategoriesList, isApiCallDone: true, loading: false };
    try {
      const data = await api.eventService.getAttendeeCountedCategories<Array<IAttendeeCountCategory>>(
        Number(eventId)
      );

      if (data && Array.isArray(data) && data.length) {
        const sortedList: Array<IAttendeeCategory> = data.sort(
          (a, b) => a.category.name.localeCompare(b.category.name)
        ).map((item) => ({
          ...item.category,
          count: Number(item?.numAttendees || 0)
        })
        );
        apiState = { ...apiState, list: [...sortedList] };
      }
      dispatch({ type: "SET_ATTENDEE_CATEGORIES_LIST", payload: apiState });
      setLoading(false);
    } catch (error: any) {
      dispatch({ type: "SET_ATTENDEE_CATEGORIES_LIST", payload: apiState });
      setLoading(false);
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  useEffect(() => {
    fetchAttendeeCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // COMPONENT RENDER CONSTANTS
  if (isLoading) return <Box sx={classes.loadingDiv}><Loading /></Box>;

  return (
    <Box sx={classes.mainDiv}>
      {!state?.attendeeCategoriesList?.action?.type && (
        <Box sx={classes.innerDiv}>
          {state?.attendeeCategoriesList?.list?.length !== 0 ? (
            <>
              <Box sx={{ flex: 1, overflow: "auto" }}>
                <CategoryList list={state?.attendeeCategoriesList?.list} />
              </Box>
              <FdButton
                variant="text"
                startIcon={<RiAddCircleLine />}
                ButtonName="Add new category"
                onClick={() => {
                  dispatch({
                    type: "SET_ATTENDEE_CATEGORY_ACTION",
                    payload: { type: "ADD" },
                  });
                }}
              />
            </>
            
           
          ) : (
            <Box sx={classes.centerDiv}>
              <Box textAlign="center">
                <BiGridAlt
                  style={classes.iconStyle}
                  size="100"
                />
                <FdTypography label="No categories have been created" />
                <FdButton
                  variant="text"
                  startIcon={<RiAddCircleLine />}
                  ButtonName="Add new Category"
                  onClick={() => {
                    dispatch({
                      type: "SET_ATTENDEE_CATEGORY_ACTION",
                      payload: { type: "ADD" },
                    });
                  }}
                  sx={{ marginTop: "10px" }}
                />
              </Box>
            </Box>
          )}
        </Box>
      )}

      {["EDIT", "ADD"].includes(
        state?.attendeeCategoriesList?.action?.type
      ) && (
        <CategoryForm
          key={state?.attendeeCategoriesList?.action?.payload?.id || 0}
          parentNotificationRef={notificationRef}
        />
      )}
      <NotificationMessage ref={notificationRef} />
    </Box>
  );
};
export default CategoryOverview;
